export default {
    events_main_title: "Eventos",
    events_main_id: "Id",
    events_main_name: "Nombre",
    events_main_add_event: "Agregar fabricante",
    events_main_firmware: "Firmware",
    events_main_events: "Fabricante",
    events_main_configuration: "Configuración por Defecto",
    events_main_canned_commands: "Comandos",
    events_main_status: "Estado",
    events_main_created_on: "Creado en",
    events_main_sync_ctc_information: "Sincronizar información del CTC",
    events_main_diagnostic: "Diagnostico",
    events_main_created_by:"Creado Por",
    events_main_updated_by:"Actualizado Por",
    events_main_updated_on:"Actualizado en",
}